export enum ConfiguratorTab {
  PRODUCTS = 'products',
  CONFIGURE = 'configure',
  DOWNLOADS = 'downloads',
}
